const formatNumber = (value: number | string | undefined) => {
  if (!value) return 0;
  if (typeof value === 'string') value = Number.parseFloat(value);
  return value.toLocaleString('pt-br');
}

export default formatNumber;